<ng-container *ngIf="product$ | async as product">
  <div [jagaHideNoContent]="!product.dimensionImage">
    <cx-media [container]="product.dimensionImage"></cx-media>
  </div>
</ng-container>
